const expansionRates = {
  sbdo: {
    20000000: 0.0125,
    50000000: 0.01,
    100000000: 0.0075,
    200000000: 0.005,
    1000000000: 0.0025
  },
  soups: {
    4000: 0.03
  }
}

export default expansionRates